import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import styles from './ClLoginModal.scss';

const ClLoginModal = (
  {
    showModal,
    toggleModal,
    noClAccountButtonHandler = toggleModal,
    hasClAccountButtonHandler = toggleModal,
  }
) => {
  return (
    <Modal
      zIndex="7000"
      isOpen={showModal}
      toggle={toggleModal}
      centered
      size="lg"
    >
      <ModalHeader
        toggle={toggleModal}
        tag="div"
        close={
          <div className={'my-auto ' + styles.closeButton}>
            <button className="close" onClick={toggleModal} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        }
      >
        <span className={styles.modalTitle}>Do you have an existing Cotality account?</span>
      </ModalHeader>
      <ModalBody
        className={styles.modalClass}
      >
        <img
          className="mx-auto d-block mw-100"
          src="/assets/images/agency/agent-centre-preview.png"
        />
        <div className={`mt-4 ${styles.smallText}`}>
          If you have an existing Cotality account you use to access other Cotality products and services (e.g. RP Data),
          you can log in now and we will pre-fill some of your details to make signing up to OnTheHouse even
          easier.
          <br /><br />
          If you don&lsquo;t have a Cotality account, that’s OK. You can easily create one as part of your sign up.
        </div>
        <div className="d-flex flex-column mt-3">
          <button className="odinButton my-1" onClick={hasClAccountButtonHandler}>I have a Cotality account</button>
          <button className="odinButton my-1" onClick={noClAccountButtonHandler}>I do not have a Cotality account</button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ClLoginModal.propTypes = {
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  noClAccountButtonHandler: PropTypes.func,
  hasClAccountButtonHandler: PropTypes.func,
};

export default ClLoginModal;
